import { render, staticRenderFns } from "./ArtistForm.vue?vue&type=template&id=8848e47a"
import script from "./ArtistForm.vue?vue&type=script&lang=js"
export * from "./ArtistForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports